import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Sparkles, X, Check } from "lucide-react";

/**
 * variant: "premium" | "family"
 * open, onClose, message (optional override), title (optional override), includedIn (optional string[] e.g. ["Premium","Family"])
 */
export default function UpgradeModal({ open, variant = "premium", message, title, includedIn, onClose }) {
  const navigate = useNavigate();
  if (!open) return null;

  const isFamily = variant === "family";
  const heading = title || (isFamily ? "Unlock Household Features" : "Unlock More With Premium");
  const body = message || (isFamily
    ? "Upgrade to Family to share reminders, calendars and documents with household members."
    : "You've reached the limit of your current plan. Upgrade for unlimited records, additional storage and premium capabilities in every hub.");
  const accent = isFamily ? "#7C3AED" : "#0F766E";
  const Icon = isFamily ? Crown : Sparkles;
  const cta = isFamily ? "Upgrade to Family" : "Upgrade Now";

  const goPricing = () => { onClose?.(); navigate(`/app/billing?plan=${isFamily ? "family" : "premium"}`); };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-testid="upgrade-modal">
      <div className="absolute inset-0 bg-[#2D3436]/45 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-7 text-center shadow-2xl">
        <button onClick={onClose} data-testid="upgrade-modal-close" className="absolute right-4 top-4 rounded-lg p-1 text-[#9aa3a0] hover:bg-[#f0f1ee]"><X className="h-4 w-4" /></button>
        <span className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl" style={{ background: `${accent}1a` }}>
          <Icon className="h-8 w-8" style={{ color: accent }} strokeWidth={1.5} />
        </span>
        <h3 className="font-display text-2xl font-semibold text-[#2D3436]">{heading}</h3>
        <p className="mx-auto mt-2 max-w-sm text-sm leading-relaxed text-[#636E72]">{body}</p>
        {includedIn?.length > 0 && (
          <div data-testid="upgrade-included-in" className="mx-auto mt-4 inline-flex flex-col gap-1.5 rounded-xl bg-[#FFFBEB] px-5 py-3 text-left">
            <span className="text-[11px] font-semibold uppercase tracking-wide text-[#B45309]">Included in</span>
            {includedIn.map((plan) => (
              <span key={plan} className="flex items-center gap-2 text-sm font-medium text-[#2D3436]"><Check className="h-4 w-4 text-[#16A34A]" /> {plan}</span>
            ))}
          </div>
        )}
        <div className="mt-7 flex flex-col gap-2.5">
          <button data-testid="upgrade-modal-cta" onClick={goPricing}
            className="rounded-xl px-6 py-3 font-medium text-white transition-transform hover:-translate-y-0.5" style={{ background: accent }}>
            {cta}
          </button>
          <button data-testid="upgrade-modal-later" onClick={onClose} className="rounded-xl px-6 py-2.5 text-sm font-medium text-[#636E72] hover:bg-[#f0f1ee]">
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}
